import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { DeputyActionsUnion, DeputyActionTypes, DeputyStateModel } from "../actions/deputy.actions";

// This adapter will allow is to manipulate VesselCallManagement
export const adapter = createEntityAdapter<DeputyStateModel>({
    selectId: (deputy: DeputyStateModel) =>
        buildSelectId('global'),
    sortComparer: false
});


export interface State extends EntityState<DeputyStateModel> {
    selectedEntityId: string | null
}

export const INIT_STATE: State = adapter.getInitialState({
    selectedEntityId: null,
});

export function reducer(state: State = INIT_STATE, action: DeputyActionsUnion) {
    switch (action.type) {

        case DeputyActionTypes.LOAD_SUBSTITUTE_SUCCESS: {
            const selectedId = buildSelectId('global');
            return adapter.upsertOne({
                currentSubstitute: action.payload
            } as DeputyStateModel, {
                    ...state,
                    selectedEntityId: selectedId
                });
        }
        case DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS_SUCCESS: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            let possibleDeputies: any;
            if (entity) {
                possibleDeputies = Object.assign([], entity.possibleDeputies);
            }
            for (let i = 0; i < action.photos.length; i++) {
                if (action.photos[i].photo) {
                    possibleDeputies[i] = Object.assign({}, { ...possibleDeputies[i], photo: action.photos[i].photo });
                }
            }
            const payload = Object.assign({}, entity, {
                possibleDeputies: possibleDeputies,
                isPhotosLoaded: true
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId
            });
        }
        
        case DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS_FAILURE: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                isPhotosLoaded: true
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId
            });
        }

        case DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES_SUCCESS: {
            const selectedId = buildSelectId('global');

            return adapter.upsertOne({
                possibleDeputies: action.payload
            } as DeputyStateModel, {
                    ...state,
                    selectedEntityId: selectedId
                });
        }

        case DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES_FAILURE: {
            const selectedId = buildSelectId('global');
            return adapter.upsertOne({
                possibleDeputies: []
            } as DeputyStateModel, {
                    ...state,
                    selectedEntityId: selectedId
                });
        }

        // case DeputyActionTypes.LOAD_SUBSTITUTE_FAILURE: {
        //     const id = buildSelectId('global');
        //     return adapter.removeOne(id, state);
        // }
        case DeputyActionTypes.LOAD_USERS_LIST_SUCCESS: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            let businessEntityUsers: any = [];
            if (action && action.payload && action.payload.results && action.payload.results.length > 0) {
                for (let i = 0; i < action.payload.results.length; i++) {
                    let value = {
                        ...action.payload.results[i],
                        checked: false
                    }
                    businessEntityUsers.push(value);
                }
            }
            const paginatedResult = { ...action.payload, results: businessEntityUsers };
            const payload = Object.assign({}, entity, {
                businessEntityUsers: paginatedResult
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.LOAD_USERS_LIST_FAILURE: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                businessEntityUsers: []
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.IMPERSONALIZE_USER_SUCCESS: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                currentImpersonalization: action.payload
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_SUCCESS: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            let possibleImpersonalizationList: any = [];
            if (action && action.payload && action.payload.results && action.payload.results.length > 0) {
                for (let i = 0; i < action.payload.results.length; i++) {
                    let value = {
                        ...action.payload.results[i],
                        checked: false
                    }
                    possibleImpersonalizationList.push(value);
                }
            }
            const paginatedResult = { ...action.payload, results: possibleImpersonalizationList };
            const payload = Object.assign({}, entity, {
                possibleImpersonalizationList: paginatedResult
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_FAILURE: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];

            return adapter.upsertOne(entity, {
                ...state,
                selectedEntityId: selectedId,
                past: [action.payload],
                present: action.payload,
                future: []
            });
        }

        case DeputyActionTypes.DELETE: {
            const id = buildSelectId('global');
            return adapter.removeOne(id, state);
        }
        case DeputyActionTypes.DELETE_BUSINESS_ENTITY_USERS: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                businessEntityUsers: null,
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.DELETE_IMPERSONALIZATION_LIST: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                possibleImpersonalizationList: null,
                businessEntityUsers: null,
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.DELETE_DEPUTY: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                currentSubstitute: null,
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        case DeputyActionTypes.DELETE_IMPERSONALIZATION: {
            const selectedId = buildSelectId('global');
            const entity = state.entities[selectedId];
            const payload = Object.assign({}, entity, {
                currentImpersonalization: null,
            });
            return adapter.upsertOne(payload, {
                ...state,
                selectedEntityId: selectedId,
                past: [payload],
                present: payload,
                future: []
            });
        }
        default:
            return state;
    }
}

export function buildSelectId(id: string): string {
    return `${id || 'new'}`;
}

export const getEntities = (state: State) => state ? state.entities : null;
